import Splide, { Components, EventInterface, SlideComponent } from "@splidejs/splide";

/**
 * Splide extension that manages CSS class "is-moving" on slides. When the Splide container is moving, the class "is-moving"
 * is added to every slide, and removed from every slide once it stops moving.
 * @see https://splidejs.com/guides/extension/
 *
 * @param splide
 * @param components
 */
export function defaultExtension(splide: Splide, components: Components) {
  const { on, off } = EventInterface(splide);

  const mount = () => {
    on("move", () => components.Slides.forEach((slide: SlideComponent) => slide.slide.classList.add("is-moving")));
    on("moved", () => components.Slides.forEach((slide: SlideComponent) => slide.slide.classList.remove("is-moving")));
  };

  const destroy = () => {
    off("move");
    off("moved");
  };

  return {
    mount,
    destroy,
  };
}
